import * as Yup from 'yup'

const locationSchema = Yup.object().shape({
  id: Yup.string().nullable(), // to differentiate between new and existing locations
  location_name: Yup.string().when('location_address', {
    is: (address: string) => !!address,
    then: Yup.string().required('validation-required'),
    otherwise: Yup.string().nullable().notRequired(),
  }),
  location_address: Yup.string()
    .max(100, 'validation-location-address-max')
    .nullable()
    .notRequired(),
  latitude: Yup.number().when('location_address', {
    is: (address: string) => !!address,
    then: Yup.number().required('validation-required'),
    otherwise: Yup.number().nullable().notRequired(),
  }),
  longitude: Yup.number().when('location_address', {
    is: (address: string) => !!address,
    then: Yup.number().required('validation-required'),
    otherwise: Yup.number().nullable().notRequired(),
  }),
  radius: Yup.number().required('validation-required').nullable(),
})

const stepSchema = Yup.object().shape({
  name: Yup.string().max(100, 'validation-name-max').nullable().required('validation-required'),
  code: Yup.string().max(100, 'validation-item-code-max').required('validation-required'),
  description: Yup.string().optional().nullable(),
  image: Yup.object().shape({
    icon: Yup.string().nullable(),
  }),
  media: Yup.array()
    .of(
      Yup.object().shape({
        title: Yup.string().nullable(false).required('validation-required'),
      }),
    )
    .optional(),
  locations: Yup.array().of(locationSchema).required('validation-required'),
})

export { stepSchema }
